import { render, staticRenderFns } from "./Date.vue?vue&type=template&id=63d2d7f1&"
import script from "./Date.vue?vue&type=script&lang=ts&"
export * from "./Date.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports